"use strict";

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** @format */

if ("NodeList" in window && !NodeList.prototype.forEach) {
	console.info("polyfill for IE11");
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (var i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

// Func = limiting Scope for this file
var lastScrollTop = 0;
var onThirdMenu = false;
var winWidth = $(window).innerWidth();
(function () {
	if (document.querySelector(".page-1305") != null) {
		console.log("eentro");
		document.querySelector(".vimeoframe").classList.remove("playing");
		document.querySelector("#stopVideo").style.display = "none";
		document.querySelector("#load-video").style.display = "none";
		document.querySelector(".play-video").style.display = "block";
	}
	$(".columns-content .show-detail").on("click", function () {
		console.log($(this).parent().find(".data-detail").html());
		$.fancybox.open($(this).parent().find(".data-detail").html());
	});

	if (document.URL.indexOf("?open=") != "-1") {
		setTimeout(function () {
			var open_li = document.URL.split("?open=");
			open_li = open_li[1];
			open_li = open_li * 1;

			var open_li_obj = $(".accordion-content .accordion-content__item")[open_li - 1];
			$(open_li_obj).find(".accordion-content__title").click();

			$("html, body").animate({ scrollTop: $(open_li_obj).offset().top }, 1500);
		}, 1000);
	}

	$("#form_id-24").on("submit", function () {
		if ($("#id_5_24").val() == "Boating") {
			$("input[name='emailcc[]']").eq(0).attr("value", "jlord@bahamas.com");
		}
	});

	$("#content .sub-menu").after("<select class='custom-sel experiences-select-mobile' name='experiences-select-mobile' id='experiences-select-mobile' placeholder='Select your experiences'></select>");
	$.each($("#content .sub-menu ul li"), function (index, value) {
		var link = $(this).find("a");
		$("#experiences-select-mobile").append('<option value="' + $(link).attr("href") + '">' + $(link).text() + "</option>");
	});
	setTimeout(function () {
		$("#experiences-select-mobile").parent().find(".form-custom-option").on("click", function () {
			document.location = $(this).data("value");
		});
	}, 1000);

	var paragraph = document.querySelectorAll("p") || [];
	paragraph.forEach(function (e) {
		return e.innerHTML.trim() === "" && e.parentNode.removeChild(e);
	});
	if (document.querySelector(".island-menu-top")) {
		var islandTrigger = document.querySelector(".island-menu-top") && document.querySelector(".island-menu-top").parentElement,
		    islandMenu = document.querySelector(".js-island-menu");

		if (window.innerWidth > 1090) {
			islandTrigger.addEventListener("mouseover", function () {
				islandMenu.classList.add("open");
			});

			islandTrigger.addEventListener("mouseout", function () {
				setTimeout(function () {
					if (!islandMenu.mouseIsOver) {
						islandMenu.classList.remove("open");
						islandMenu.mouseIsOver = false;
					}
				}, 300);
			});

			islandMenu.addEventListener("mouseover", function () {
				islandMenu.classList.add("open");
				islandMenu.mouseIsOver = true;
			});

			islandMenu.addEventListener("mouseout", function () {
				islandMenu.classList.remove("open");
				islandMenu.mouseIsOver = false;
			});
		} else {
			var closeMenus = function closeMenus() {
				$("#privary-navigation li").removeClass("hover");
				$("#privary-navigation li").removeClass("level-3");
				$("#privary-navigation li").find("> ul.submenu", this).css("display", "none");
				$("#secondary-navigation li").removeClass("hover");
				$("#secondary-navigation li").removeClass("level-3");
				$("#secondary-navigation li").find("> ul.submenu", this).css("display", "none");
				$(".new-island-menu").removeClass("open");
			};

			$("#primary-nav li a").on("click", function (event) {
				closeMenus();
				if ($(this).siblings(".submenu").size() > 0) {
					event.preventDefault();
					$(this).parent().addClass("hover");
					$(this).parent().find("> ul.submenu", this).fadeIn(200);
					$(".new-island-menu").removeClass("open");
				}
			});

			$("#secondary-navigation li a").on("click", function (event) {
				closeMenus();
				if ($(this).siblings(".submenu").size() > 0) {
					event.preventDefault();
					$(this).parent().addClass("hover");
					$(this).parent().find("> ul.submenu", this).css("display", "flex");
					$(".new-island-menu").removeClass("open");
				}
			});

			$(".level-2").on("click", function () {
				$(this).parent().parent().parent().addClass("level-3");
				$(this).siblings(".submenu").addClass("third-sub");
				$(".third-sub, .third-sub li").click(function () {
					$(".third-sub").parent().parent().parent().addClass("level-3");
					onThirdMenu = true;
					console.log("entra a third menu");
				});
				$("ul.submenu", this).fadeIn(200);
				onThirdMenu = true;
				console.log("entra");
			});

			$(islandTrigger).on("click", function (event) {
				if (islandTrigger.querySelector(".new-island-menu")) {
					console.log(islandTrigger);
					closeMenus();
					event.preventDefault();
					$(".new-island-menu").addClass("open");
				}
			});

			$(document).click(function (e) {
				var container = $("#header");
				if (!container.is(e.target) && container.has(e.target).length === 0) {
					closeMenus();
				}
			});

			if (document.getElementsByClassName("navigation")[0] && document.getElementsByClassName("navigation")[0].getElementsByTagName("a")) {
				document.getElementsByClassName("navigation")[0].querySelectorAll("a").forEach(function (link) {
					link.addEventListener("click", function (e) {
						if (link.nextElementSibling) {
							var nextSibling = link.nextElementSibling.classList.contains("sub-sub-menu");
							if (nextSibling) {
								e.preventDefault();
								link.nextElementSibling.classList.toggle("open");
							}
						}
					});
				});
				if (document.getElementsByClassName("mobile-sub").length > 0) {
					document.querySelectorAll(".mobile-sub").forEach(function (subNav) {
						subNav.addEventListener("click", function (e) {
							if (subNav.nextElementSibling) {
								var nextSibling = subNav.nextElementSibling.classList.contains("submenu");
								if (nextSibling) {
									e.preventDefault();
									subNav.nextElementSibling.classList.toggle("open");
								}
							}
						});
					});
				}
			}
		}

		$("#check-in").on("click", function (e) {
			e.preventDefault();
			$("#dateCalendar").addClass("open-calendar");
			$(".booking-fields").css("opacity", "0");
		});

		$(".close-calendar").on("click", function () {
			$("#dateCalendar").removeClass("open-calendar");
			$(".booking-fields").css("opacity", "1");
			updateTabIndex();
		});
		$(".close-calendar__bottom").on("click", function () {
			$("#dateCalendar").removeClass("open-calendar");
			$(".booking-fields").css("opacity", "1");
		});
	}

	//homepage pop in
	$(".pop-out-banner .close-banner").click(function (e) {
		e.preventDefault();
		$(".pop-out-banner").addClass("closed");
	});

	//homepage pop in anniversary
	if (document.querySelector(".pop-out-banner-anniversary")) {
		window.addEventListener("scroll", function () {
			var breakpoint = window.innerHeight / 2;
			document.querySelector(".pop-out-banner-anniversary").classList.toggle("delay-popin", window.scrollY < breakpoint);

			console.log(breakpoint, window.scrollY);
		});
	}

	$(".pop-out-banner-anniversary .close-banner").click(function (e) {
		e.preventDefault();
		$(".pop-out-banner-anniversary").addClass("closed");
	});

	// getting here navigation Dropdown
	$(".sub-menu li").hover(function () {
		$(this).addClass("hover");
		$("ul.privary-navigation__submenu", this).fadeIn(200);
	}, function () {
		$(this).removeClass("hover");
		$("ul.privary-navigation__submenu", this).fadeOut(200);
	});

	$(".js-icons-info-slides").slick({
		slidesToShow: 3,
		arrows: true,
		accessibility: true,
		responsive: [{
			breakpoint: 1000,
			settings: {
				slidesToShow: 2
			}
		}, {
			breakpoint: 768,
			settings: {
				slidesToShow: 1,
				adaptiveHeight: true
			}
		}]
	});

	$(".mob-slide").slick();

	$(".slider-three-columns-block-slides").slick({
		accessibility: true,
		slidesToShow: 3,
		autoplay: true,
		autoplaySpeed: 4000,
		speed: 400,
		adaptiveHeight: true,
		arrow: true,
		responsive: [{
			breakpoint: 1000,
			settings: {
				slidesToShow: 2,
				infinite: true
			}
		}, {
			breakpoint: 700,
			settings: {
				slidesToShow: 1,
				fade: true,
				// adaptiveHeight: false,
				autoplay: false,
				arrow: false
			}
		}]
	});

	$(".slider-columns-icon-slides").slick({
		accessibility: true,
		slidesToShow: 3,
		autoplay: true,
		autoplaySpeed: 4000,
		speed: 400,
		adaptiveHeight: true,
		arrows: true,
		responsive: [{
			breakpoint: 1000,
			settings: {
				slidesToShow: 2,
				infinite: true
			}
		}, {
			breakpoint: 700,
			settings: {
				slidesToShow: 1,
				fade: true,
				adaptiveHeight: false,
				arrows: false,
				dots: true
			}
		}]
	});

	$(".tropical__btm-txt").slick({
		arrows: false,
		fade: true,
		autoplay: true,
		accessibility: true,
		autoplaySpeed: 2500,
		speed: 1000,
		pauseOnHover: false
	});

	$(".numbers-slider").each(function () {
		var $thisEl = $(this);
		var $thisWrapper = $thisEl.closest(".numbers-slider__wrapper");
		var $thisCount = $thisWrapper.find(".numbers-slider__counter");
		$thisEl.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
			$thisCount.find(".current").html(nextSlide + 1);
		});
	});

	$(".easy-scroll").click(function () {
		var target = $(this).attr("href");
		if ($("body.main").length > 0) {
			var padding = 0;
		} else {
			var padding = $("header").height() - 90;
		}
		$("html, body").animate({ scrollTop: $(target).offset().top - padding }, 1500);
		return false;
	});

	var fixedBtnHeight = $("#index").height();
	var windowheight = $(window).height();

	$("#microsite").each(function (index, sliderWrap) {
		var $slider = $(sliderWrap).find(".global-slider");
		var $next = $(sliderWrap).find(".next");
		var $prev = $(sliderWrap).find(".prev");
		$slider.slick({
			dots: false,
			autoplay: false,
			speed: 500,
			fade: true,
			accessibility: true,
			prevArrow: $prev,
			nextArrow: $next,
			responsive: [{
				breakpoint: 1090,
				settings: {
					arrows: false,
					prevArrow: false,
					nextArrow: false,
					adaptiveHeight: true
				}
			}]
		});
	});

	function updateOnScroll(element) {
		window.addEventListener("scroll", function () {
			document.body.classList.toggle("scrolled", window.scrollY > 100);
			element.classList.toggle("visible", window.scrollY > 100);
		});
	}

	if (document.querySelector("#hip-fav-widget")) {
		var top_widget = document.querySelector("#hip-fav-widget");
		updateOnScroll(top_widget);
	}

	if (document.querySelector("#divSatisfiChat")) {
		var chat_widget = document.querySelector("#divSatisfiChat");
		updateOnScroll(chat_widget);
	}

	if (document.cookie.indexOf("exitintent-custom=1") < 0) {
		document.addEventListener("mouseout", onExitIntent);
	}
})();

function onExitIntent(e) {
	if (e.clientY < 5 && !e.toElement && !e.relatedTarget) {
		document.removeEventListener("mouseout", onExitIntent);
		$.fancybox.open("#eiModal");
		document.cookie = "exitintent-custom=1;expires=" + new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toUTCString() + ";";
	}
}

function scrollW() {
	//check scroll down or up for header styles
	var st = window.pageYOffset || document.documentElement.scrollTop;
	var mobileFilter = document.getElementById("cta-filter");
	var contactForm = document.getElementById("contact-cta-filter");
	var weddingForm = document.getElementById("open-fixed-form-btn");
	//let mobileMenu = document.getElementById('menu-mobile')
	var filterForm = document.getElementById("filter-form");
	var islandMenu = document.getElementById("destinations-nav");
	var fixedBtnForm = document.getElementById("fixed-form-btn");

	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById("header").classList.contains("down")) {
				document.getElementById("header").classList.add("down");
				document.getElementById("header").classList.remove("up");

				if (filterForm) {
					filterForm.classList.add("search-form--down");
					filterForm.classList.remove("search-form--up");
				}

				if (islandMenu) {
					islandMenu.classList.add("down");
					islandMenu.classList.remove("up");
				}

				if (mobileFilter) {
					mobileFilter.classList.add("mobile-search__down");
					mobileFilter.classList.remove("mobile-search__up");
				}
				if (contactForm) {
					contactForm.classList.add("mobile-search__down");
					contactForm.classList.remove("mobile-search__up");
				}
				if (weddingForm) {
					weddingForm.classList.add("wedding-form-btn__down");
					weddingForm.classList.remove("wedding-form-btn__up");
				}
			}
		} else {
			// upscroll code
			if (!document.getElementById("header").classList.contains("up")) {
				document.getElementById("header").classList.add("up");
				document.getElementById("header").classList.remove("down");

				if (filterForm) {
					filterForm.classList.remove("search-form--down");
					filterForm.classList.add("search-form--up");
				}

				if (islandMenu) {
					islandMenu.classList.remove("down");
					islandMenu.classList.add("up");
				}

				if (mobileFilter) {
					mobileFilter.classList.remove("mobile-search__down");
					mobileFilter.classList.add("mobile-search__up");
				}
				if (contactForm) {
					contactForm.classList.remove("mobile-search__down");
					contactForm.classList.add("mobile-search__up");
				}
				if (weddingForm) {
					weddingForm.classList.remove("wedding-form-btn__down");
					weddingForm.classList.add("wedding-form-btn__up");
				}
			}
		}
	} else {
		if (document.getElementById("header").classList.contains("up") || document.getElementById("header").classList.contains("down")) {
			document.getElementById("header").classList.remove("up");
			document.getElementById("header").classList.remove("down");

			if (filterForm) {
				filterForm.classList.remove("search-form--down");
				filterForm.classList.remove("search-form--up");
			}

			if (islandMenu) {
				islandMenu.classList.remove("down");
				islandMenu.classList.remove("up");
			}

			if (mobileFilter) {
				mobileFilter.classList.remove("mobile-search__down");
				mobileFilter.classList.remove("mobile-search__up");
			}

			if (contactForm) {
				contactForm.classList.remove("mobile-search__down");
				contactForm.classList.remove("mobile-search__up");
			}
			if (weddingForm) {
				weddingForm.classList.remove("wedding-form-btn__down");
				weddingForm.classList.remove("wedding-form-btn__up");
			}
		}
	}

	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

	var window_height = window.innerHeight;
	var animatedEl = document.getElementsByClassName("animate-fade-2");
	for (var i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		var topPos = viewportOffset.top;
		if (topPos <= window_height * 0.8) {
			animatedEl[i].classList.add("fade-in");
		}
	}
}

$(window).on("load", function () {
	var redirecting = false;
	scrollW();
	window.addEventListener("scroll", function () {
		scrollW();
	});
});

//UVP ENTRY TEXT
setTimeout(function () {
	$(".top-content-island .uvp").addClass("in");
}, 500);

//Sliders
$(window).on("load", function () {
	if ($(".home-slider, .slider").length > 0) {
		$(".home-slider, .slider").each(function (index, sliderWrap) {
			var $slider = $(sliderWrap).find(".sym-slides");
			var $next = $(sliderWrap).find(".rightArrow");
			var $prev = $(sliderWrap).find(".leftArrow");
			var $dots = $(sliderWrap).find(".dots-container");
			$slider.slick({
				dots: true,
				autoplay: false,
				speed: 500,
				fade: true,
				accessibility: true,
				prevArrow: $prev,
				nextArrow: $next,
				responsive: [{
					breakpoint: 1090,
					settings: {
						arrows: false,
						prevArrow: false,
						nextArrow: false,
						adaptiveHeight: true
					}
				}]
			});
		});
	}
});

$(".home-culture").each(function (index, sliderCulture) {
	var $sliderEx = $(sliderCulture).find(".sym-slides");
	var $next = $(sliderCulture).find(".rightArrow");
	var $prev = $(sliderCulture).find(".leftArrow");
	$sliderEx.slick({
		autoplay: false,
		speed: 500,
		fade: true,
		accessibility: false,
		prevArrow: $prev,
		nextArrow: $next,
		responsive: [{
			breakpoint: 768,
			settings: {
				arrows: false,
				dots: true,
				adaptiveHeight: true
			}
		}]
	});
});

$(".home-promotions").each(function (index, sliderCulture) {
	var _$sliderEx$slick;

	var $sliderEx = $(sliderCulture).find(".sym-slides");
	var $next = $(sliderCulture).find(".rightArrow");
	var $prev = $(sliderCulture).find(".leftArrow");
	$sliderEx.slick((_$sliderEx$slick = {
		dots: true,
		accessibility: true,
		autoplay: false,
		speed: 500,
		fade: true
	}, _defineProperty(_$sliderEx$slick, "accessibility", false), _defineProperty(_$sliderEx$slick, "prevArrow", $prev), _defineProperty(_$sliderEx$slick, "nextArrow", $next), _$sliderEx$slick));
});

$(".slider").each(function (index) {
	$(".sym-slides").on("beforeChange", function (event, slick, currentSlide, nextSlide) {
		var activeSlide = nextSlide + 1;
		//console.log(activeSlide);
		var slide_child = ":nth-child(" + activeSlide + ")";
		//console.log(slide_child);
		//$('.sym-slides .slick-slide' + slide_child).addClass("activadisimo");
		$(".sym-slides .slick-slide" + slide_child).find(".slick-dots li" + slide_child).find("button").css("background-color", "#0096bb");
		// console.log('.sym-slides .slick-track' + slide_child + '');
		// console.log('.slick-dots li' + slide_child + '');
	});
});

$(".experience-slider").each(function (index, sliderExp) {
	var _$sliderEx$slick2;

	var $sliderEx = $(sliderExp).find(".sym-slides");
	var $next = $(sliderExp).find(".rightArrow");
	var $prev = $(sliderExp).find(".leftArrow");
	$sliderEx.slick((_$sliderEx$slick2 = {
		dots: false,
		accessibility: true,
		autoplay: false,
		speed: 500,
		fade: true
	}, _defineProperty(_$sliderEx$slick2, "accessibility", false), _defineProperty(_$sliderEx$slick2, "prevArrow", $prev), _defineProperty(_$sliderEx$slick2, "nextArrow", $next), _defineProperty(_$sliderEx$slick2, "responsive", [{
		breakpoint: 900,
		settings: {
			dots: true,
			arrows: false,
			prevArrow: false,
			nextArrow: false
		}
	}]), _$sliderEx$slick2));
});

$(".carousel").each(function (index, carouselrWrap) {
	var $slider = $(carouselrWrap).find(".sym-slides");
	$slider.slick({
		dots: true,
		arrows: false,
		autoplay: false,
		speed: 500,
		fade: true,
		accessibility: true,
		// appendDots: $dots,
		responsive: [{
			breakpoint: 480,
			settings: {
				dots: true,
				arrows: false,
				prevArrow: false,
				nextArrow: false
			}
		}]
	});
});
$(".hotels-slider").each(function (index, sliderWrap) {
	var $slider = $(sliderWrap).find(".sym-slides");
	var $next = $(sliderWrap).find(".rightArrow");
	var $prev = $(sliderWrap).find(".leftArrow");
	$slider.slick({
		dots: false,
		autoplay: false,
		speed: 500,
		fade: true,
		accessibility: true,
		prevArrow: $prev,
		nextArrow: $next,
		responsive: [{
			breakpoint: 480,
			settings: {
				dots: true,
				arrows: false,
				prevArrow: false,
				nextArrow: false
			}
		}]
	});
});

$(".custom-slider").slick();

$(".tour").each(function (index, sliderCont) {
	var $sliderCont = $(sliderCont).find(".tour-slider");
	var $prev = $(sliderCont).find(".leftArrow");
	var $next = $(sliderCont).find(".rightArrow");
	$sliderCont.slick({
		dots: true,
		autoplay: false,
		//speed: 500,
		//fade: true,
		accessibility: true,
		infinite: true,
		slidesToShow: 1,
		prevArrow: $prev,
		nextArrow: $next,
		responsive: [{
			breakpoint: 800,
			settings: {
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				centerMode: true,
				centerPadding: "6%",
				variableWidth: false,
				adaptiveHeight: true
			}
		}, {
			breakpoint: 600,
			settings: {
				dots: true
			}
		}]
	});
});

$(".islands-slider").each(function (index, sliderIsland) {
	var $sliderIsland = $(sliderIsland).find(".sym-slides");
	var $next = $(sliderIsland).find(".rightArrow");
	var $prev = $(sliderIsland).find(".leftArrow");

	$sliderIsland.slick({
		dots: false,
		autoplay: false,
		speed: 500,
		fade: true,
		accessibility: true,
		prevArrow: $prev,
		nextArrow: $next,
		responsive: [{
			breakpoint: 480,
			settings: {
				dots: true,
				arrows: false,
				prevArrow: false,
				nextArrow: false
			}
		}]
	});
});

$(".tabs-slider").each(function (index, tabSlider) {
	var $tabSlider = $(tabSlider).find(".tabs-slider__content");
	var $next = $(tabSlider).find(".rightArrow");
	var $prev = $(tabSlider).find(".leftArrow");
	var $tabSliderList = $(tabSlider).find(".tabs-slider__list li");

	$tabSlider.slick({
		fade: true,
		accessibility: true,
		prevArrow: $prev,
		nextArrow: $next
	});
	$($tabSliderList).click(function () {
		var this_index = $(this).index();
		$($tabSlider).slick("slickGoTo", this_index);
	});
	$(tabSlider).on("beforeChange", function (event, slick, currentSlide, nextSlide) {
		$($tabSliderList).removeClass("active");
		$($tabSliderList).eq(nextSlide).addClass("active");
	});
});

$(".chain-slider").each(function (index, ChainSlider) {
	var $chainSlider = $(ChainSlider).find(".sym-slides");
	var $next = $(ChainSlider).find(".rightArrow");
	var $prev = $(ChainSlider).find(".leftArrow");
	$chainSlider.slick({
		infinite: true,
		slidesToShow: 2,
		slidesToScroll: 1,
		dots: false,
		speed: 500,
		accessibility: true,
		prevArrow: $prev,
		nextArrow: $next,
		responsive: [{
			breakpoint: 1090,
			settings: {
				slidesToShow: 1,
				dots: true,
				arrows: false,
				prevArrow: false,
				nextArrow: false
			}
		}]
	});
});

$(".inspired-quad__cont").slick({
	infinite: false,
	slidesToShow: 3,
	accessibility: true,
	slidesToScroll: 1,
	responsive: [{
		breakpoint: 800,
		settings: {
			slidesToShow: 2,
			slidesToScroll: 1
		}
	}, {
		breakpoint: 480,
		settings: {
			slidesToShow: 1,
			slidesToScroll: 1
		}
	}]
});

if ($(".js-linkTo").length > 0) {
	$(".js-linkTo").click(function () {
		var dataTarget = $(this).attr("data-target");
		if ($("#" + dataTarget).length > 0) {
			animateTo(dataTarget);
		}
	});
}

//DISCOVER QUAD
var elements = document.getElementsByClassName("discover-item");
var current = $(".selection").attr("data-target");

$(".discover-cont").slick({
	infinite: true,
	accessibility: true,
	slidesToShow: 3,
	slidesToScroll: 1,
	responsive: [{
		breakpoint: 800,
		settings: {
			infinite: true,
			slidesToShow: 2,
			slidesToScroll: 1
		}
	}, {
		breakpoint: 600,
		settings: {
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			centerMode: true,
			centerPadding: "6%"
		}
	}]
});

var custom_option = $(".custom-option");
for (var m = 0; m < custom_option.length; m++) {
	$(custom_option[m]).click(function () {
		var this_val = $(this).attr("data-target");
		$(".discover-cont").slick("unslick");
		$(".discover-item").addClass("non-slick-slider");
		//$('.discover-item.'+this_val+'').removeClass('non-slider');
	});
}

function callSlick() {
	$(".discover-cont").slick("unslick");
	$(".discover-cont").slick({
		infinite: false,
		slidesToShow: 3,
		accessibility: true,
		slidesToScroll: 1,
		responsive: [{
			breakpoint: 800,
			settings: {
				infinite: true,
				slidesToShow: 2,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 600,
			settings: {
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}]
	});
}

//change island
function newChangeIsland(current) {
	var filter = current;
	if (filter == "all") {
		for (var i = 0; i < elements.length; i++) {
			elements[i].classList.remove("non-slider");
			elements[i].classList.add("slick-slide");
		}
		callSlick();
	} else {
		for (var i = 0; i < elements.length; i++) {
			elements[i].classList.add("non-slider");
			elements[i].classList.remove("slick-slide");
			if (elements[i].classList.contains(current)) {
				elements[i].classList.add("slick-slide");
				elements[i].classList.remove("non-slider");
			}
			callSlick();
		}
		var _htmlElement = document.querySelectorAll(".discover-cont ." + current);
		$(".discover-cont").slick("unslick");
		if (_htmlElement.length > 2) {
			$(".discover-cont").slick({
				infinite: false,
				accessibility: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				responsive: [{
					breakpoint: 800,
					settings: {
						infinite: true,
						slidesToShow: 2,
						slidesToScroll: 1
					}
				}, {
					breakpoint: 600,
					settings: {
						infinite: true,
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}]
			});
		}
	}
}

//CUSTOM SELECT
$(".custom-select-trigger").click(function () {
	$("html").one("click", function () {
		$(".custom-select").removeClass("opened");
	});
	$(this).parents(".custom-select").toggleClass("opened");
	event.stopPropagation();
});
$(".custom-option").on("click", function () {
	$(this).parents(".custom-select").find("selection").val($(this).data("target"));
	$(this).parents(".custom-options").find(".custom-option").removeClass("selection");
	$(this).addClass("selection");
	$(this).parents(".custom-select").removeClass("opened");
	$(this).parents(".custom-select").find(".custom-select-trigger").text($(this).text());
	var current = $(".selection").attr("data-target");

	newChangeIsland(current);
});

//language dropdown
$(function () {
	$(".language").on("click", function () {
		$(this).toggleClass("active");
	});
	var lang_list = $(".language .dropdown > li");
	$(lang_list).on("click", function () {
		var opt = $(this);
		lang_list.val = $(this).text();
		lang_list.index = $(this).index();
		$("#drop-lang span").text($(this).text());
		var langSel = $(this).text().toLowerCase();
		var pathname = document.location.pathname;
		var origin = document.location.origin;
		var langs = ["es", "fr", "de", "pt", "it"];
		for (var key in langs) {
			if (pathname.indexOf("/" + langs[key] + "/") > -1) pathname = pathname.replace("/" + langs[key] + "/", "");
		}

		if (langSel != "en") {
			if ($("body").attr("id") === "home") document.location = origin + "/" + langSel;else {
				var newUrl = langSel + "/" + pathname;
				newUrl = newUrl.replace("//", "/");
				document.location = origin + "/" + newUrl;
			}
		} else {
			if ($("body").attr("id") === "home") document.location = origin + "/";else document.location = origin + "/" + pathname;
		}
	});
});

if (window.innerWidth < 1090) {
	var openMenu = function openMenu() {
		menu.classList.add("open");
		_htmlElement2.classList.add("hide-overflow");
		if (searchFilter) {
			searchFilter.classList.remove("open");
		}
		if (ctaFilter) {
			ctaFilter.classList.remove("open");
		}
	};

	var closeMenu = function closeMenu() {
		menu.classList.remove("open");
		_htmlElement2.classList.remove("hide-overflow");
	};

	//MOBILE SEARCH FORM OPEN FUNCTION
	var toggleFilter = function toggleFilter() {
		var textFormBtn = ctaFilter.getElementsByClassName("label")[0];

		ctaFilter.classList.toggle("open");
		searchFilter.classList.toggle("open");
		_htmlElement2.classList.toggle("hide-overflow");

		if (ctaFilter.classList.contains("open")) {
			ctaFilter.getElementsByClassName("label")[0].innerHTML = "close search";
		} else {
			ctaFilter.getElementsByClassName("label")[0].innerHTML = "refine your search";
		}
	};

	//MENU MOBILE OPEN FUNCTION
	var menu = document.getElementById("menu");
	var ctaMenu = document.getElementById("btn-menu");
	var _htmlElement2 = document.querySelector("html");
	var ctaCloseMenu = document.getElementById("menu-close");
	var searchFilter = document.getElementById("filter-form");
	var ctaFilter = document.getElementById("cta-filter");
	var closeFilter = document.getElementById("search-header-mobile");
	var showSearchMobile = document.querySelector(".show-search-mobile");

	if (ctaMenu) {
		ctaMenu.addEventListener("click", openMenu);
	}
	if (ctaCloseMenu) {
		ctaCloseMenu.addEventListener("click", closeMenu);
	}
	if (ctaFilter) {
		ctaFilter.addEventListener("click", toggleFilter);
	}
	if (closeFilter) {
		closeFilter.addEventListener("click", function () {
			ctaFilter.classList.remove("open");
			searchFilter.classList.remove("open");
			_htmlElement2.classList.remove("hide-overflow");
			showSearchMobile.querySelector(".label").innerText = "Refine your search";
		});
	}

	if ($("#contact-cta-filter").length) {
		$("#contact-cta-filter").click(function () {
			$(this).toggleClass("open");
			$(".contact-form").toggleClass("open");
		});
	}
}

//EVENTS FORM
var eventFormBtn = document.getElementById("fixed-form-btn");
var eventFormBtnAlt = document.getElementById("open-fixed-form-btn");
var eventForm = document.getElementById("fixed-form");
var closeFormBtn = document.getElementById("close-form");
var closeFormClickOut = document.getElementById("fixed-form__bg");
var htmlElement = document.querySelector("html");

function openForm() {
	eventFormBtn.classList.add("open");
	eventForm.classList.add("open");

	htmlElement.classList.add("hide-overflow");
}

function closeForm() {
	eventFormBtn.classList.remove("open");
	//eventFormBtnAlt.classList.remove('open');
	eventForm.classList.remove("open");
	htmlElement.classList.remove("hide-overflow");
}

if (eventFormBtn) {
	eventFormBtn.addEventListener("click", openForm);
}
if (eventFormBtnAlt) {
	eventFormBtnAlt.addEventListener("click", openForm);
	eventFormBtnAlt.classList.add("open");
}
if (closeFormBtn) {
	closeFormBtn.addEventListener("click", closeForm);
	if (eventFormBtnAlt) {
		eventFormBtnAlt.classList.remove("open");
	}
}
if (closeFormClickOut) {
	closeFormClickOut.addEventListener("click", closeForm);
}

//INTRO CONTENT ANCHOR
$(".intro-content__text a").click(function () {
	var intro_href = $(this).attr("href");
	var intro_href_top = $(intro_href).offset().top;
	$("html,body").animate({
		scrollTop: intro_href_top
	}, 1200);
});

//REGULATIONS ACCORDION
$(".regulations-content__btn a").click(function (e) {
	e.preventDefault();
	var this_href = $(this).attr("href");

	//const this_href_bot = $(this_href).this_href_top + $(this).outerHeight();
	$(".regulations-content__btn a").removeClass("active");
	$(".regulations-content__item").removeClass("open");
	var this_href_top = $(this_href).offset().top;
	console.log($(this).parent().parent().parent().find(this_href));
	$("html,body").animate({
		scrollTop: this_href_top
	}, 1200);

	$(this).addClass("active");
	$(this).parent().parent().parent().find(this_href).addClass("open");
});

$(".regulations-content__item .regulations-content__title").click(function () {
	$(this).parent().toggleClass("open");

	var itemID = $(this).attr("id");

	$(".regulations-content__btn a." + itemID).toggleClass("active");
});

var hash = document.getElementById(window.location.hash.replace("#", ""));
hash && hash.classList.add("open");

//range price bar
document.documentElement.classList.add("js");

addEventListener("input", function (e) {
	var _t = e.target,
	    _p = _t.parentNode;

	_p.style.setProperty("--" + _t.id, +_t.value);
}, false);

//TRAVEL FORM CUSTOM SELECT
$(".custom-sel").each(function () {
	var classes = $(this).attr("class"),
	    id = $(this).attr("id"),
	    name = $(this).attr("name");
	var template = '<div class="' + classes + '">';
	template += '<span class="custom-sel-trigger">' + $(this).attr("placeholder") + "</span>";
	template += '<div class="form-custom-options">';
	$(this).find("option").each(function () {
		template += '<span class="form-custom-option ' + $(this).attr("class") + '" data-value="' + $(this).attr("value") + '">' + $(this).html() + "</span>";
	});
	template += "</div></div>";

	$(this).wrap('<div class="custom-sel-wrapper"></div>');
	$(this).hide();
	$(this).after(template);
});
$(".form-custom-option:first-of-type").hover(function () {
	$(this).parents(".form-custom-options").addClass("option-hover");
}, function () {
	$(this).parents(".form-custom-options").removeClass("option-hover");
});
$(".custom-sel-trigger").on("click", function () {
	$("html").one("click", function () {
		$(".custom-sel").removeClass("opened");
	});
	$(this).parents(".custom-sel").toggleClass("opened");
	event.stopPropagation();
});
$(".form-custom-option").on("click", function () {
	$(this).parents(".custom-sel-wrapper").find("select").val($(this).data("value"));
	$(this).parents(".form-custom-options").find(".form-custom-option").removeClass("selection");
	$(this).addClass("selection");
	$(this).parents(".custom-sel").removeClass("opened");
	$(this).parents(".custom-sel").find(".custom-sel-trigger").text($(this).text());
});

var currentFlightOption = "hotel";
var currentOption = "Agent";
var airport_selected = "";
var airport_name = "";
var airport_selected_aux = "";
var ua = navigator.userAgent.toLowerCase();
var websiteID = 0;

function prepareQueryBusyRooms(booking_type) {
	airport_selected_aux = $("#airport").val();
	airport_selected = airport_selected_aux.split(", ")[0];
	airport_name = airport_selected_aux.split(", ")[1];

	var ua = navigator.userAgent.toLowerCase();
	var isMobile = ua.indexOf("mobile") == "-1" ? false : true;

	if ($(".airport .custom-sel-trigger").text() == "Origin Airport") {
		$("#airport-error").removeClass("hidden");
		return;
	} else {
		$("#airport-error").addClass("hidden");
	}

	var destination = isMobile ? $("#establishmentDestinationInput1").val() : $(".island-parent-air .selection").data("value");
	var establishment = ""; //$("#estabSelect_" + $("#ddDestEstablishment").val()).val();

	var dateTo = $("#Checkin").val().split("-")[1];
	var dateFrom = $("#Checkin").val().split("-")[0];

	dateFrom = dateFrom.split("/");
	dateFrom = new Date(dateFrom[2], dateFrom[0] - 1, dateFrom[1]);

	dateTo = dateTo.split("/");
	dateTo = new Date(dateTo[2], dateTo[0] - 1, dateTo[1]);

	dateFrom.setMinutes(dateFrom.getMinutes() + dateFrom.getTimezoneOffset() * -1);
	dateTo.setMinutes(dateTo.getMinutes() + dateTo.getTimezoneOffset() * -1);

	var passengerGroups = [];
	var ddRoomNo = $(".rooms-options").length;
	var ddflight = airport_selected;

	var establishmentIDs = [];
	var destinationCodes = [];

	var flight = {
		Origin: ddflight,
		OriginName: airport_name,
		Destination: destination
	};

	console.log(flight);

	destinationCodes.push(destination);
	if (establishment != "") {
		establishmentIDs.push(establishment);
	}

	var accomodation = "";
	if (currentOption == "") {
		accomodation = {
			EstablishmentIDs: establishmentIDs,
			DestinationCodes: destinationCodes
		};
	} else if (currentOption == "PromoCode") {
		var promoCode = $("#inPromoCode").val();
		accomodation = {
			EstablishmentIDs: establishmentIDs,
			DestinationCodes: destinationCodes,
			PromoCode: promoCode
		};
	} else if (currentOption == "Agent") {
		var AgentCode = $("#inAgentUsername").val();
		var AgentPassword = $("#inAgentPassword").val();

		accomodation = {
			EstablishmentIDs: establishmentIDs,
			DestinationCodes: destinationCodes,
			AgentUsername: AgentCode,
			AgentPassword: AgentPassword
		};
	}

	var adultsInRoom = 0;
	var childInRoom = 0;
	var childrenAges = [];

	$.each($(".rooms-options"), function (i, value) {
		adultsInRoom = 0;
		childInRoom = 0;
		childrenAges = [];

		$(value).find("#adults").parent().find(".custom-sel-trigger").text();

		if (!isMobile) {
			if ($(value).find("#adults").length > 0) {
				adultsInRoom += $(value).find("#adults").parent().find(".custom-sel-trigger").text() * 1;
				childInRoom += $(value).find("#children").parent().find(".custom-sel-trigger").text() * 1;
			} else {
				adultsInRoom += $(value).find("#adults" + i).parent().find(".custom-sel-trigger").text() * 1;
				childInRoom += $(value).find("#children" + i).parent().find(".custom-sel-trigger").text() * 1;
			}
		} else {
			if ($(value).find("#adults").length > 0) {
				adultsInRoom += $(value).find("#adults").val() * 1;
				childInRoom += $(value).find("#children").val() * 1;
			} else {
				adultsInRoom += $(value).find("#adults" + i).val() * 1;
				childInRoom += $(value).find("#children" + i).val() * 1;
			}
		}

		if (!adultsInRoom) adultsInRoom = 1;

		if (!isMobile) {
			for (var x = 1; x <= parseInt(childInRoom); x++) {
				var childAgeInRoom = $(value).find(".children-age-" + x).val();
				childrenAges.push(parseInt(childAgeInRoom));
			}
		} else {
			for (var x = 1; x <= parseInt(childInRoom); x++) {
				var childAgeInRoom = $(value).find(".children-age-" + x).val();
				childrenAges.push(parseInt(childAgeInRoom));
			}
		}

		if (adultsInRoom) {
			passengerGroups.push({
				adults: parseInt(adultsInRoom),
				childrenAges: childrenAges
			});
		}
	});

	var query = "";
	var module = [];

	if (booking_type == "hotel-air") {
		var query = {
			DateFrom: dateFrom,
			DateTo: dateTo,
			LanguageCode: current_lan,
			CurrencyCode: "US",
			PassengerGroups: passengerGroups,
			Accommodation: accomodation,
			Flights: flight,
			Destination: destination
		};
		if (typeof dataLayer != "undefined") {
			dataLayer.push({
				event: "bookingWidget",
				name: "Hotel + Air"
			});
		}
		module.push("Accommodation");
		module.push("Flights");
	} else if (booking_type == "air") {
		var query = {
			DateFrom: dateFrom,
			DateTo: dateTo,
			LanguageCode: current_lan,
			CurrencyCode: "US",
			PassengerGroups: passengerGroups,
			Accommodation: accomodation,
			Flights: flight,
			Destination: destination
		};
		if (typeof dataLayer != "undefined") {
			dataLayer.push({
				event: "bookingWidget",
				name: "Air"
			});
		}

		module.push("Flights");
	}

	if (booking_type == "hotel-air") {
		var websiteID = 1560;
		var returnURL = "https://bahamas2.direct-reservation.net/" + "?websiteID=" + websiteID + "&query=" + JSON.stringify(query) + "&modules=" + JSON.stringify(module);
	} else {
		var websiteID = 1591;
		var returnURL = "https://bahamasflights.direct-reservation.net/" + "?websiteID=" + websiteID + "&query=" + JSON.stringify(query) + "&modules=" + JSON.stringify(module);
	}

	console.log(returnURL);
	window.open(returnURL);
}

function prepareQueryDirect() {
	airport_selected = $("#airport").val();
	airport_selected = airport_selected.split(", ")[0];

	var date_1 = $("#Checkin").val().split("-")[0];
	var date_2 = $("#Checkin").val().split("-")[1];

	var date1 = new Date(date_1);
	var date2 = new Date(date_2);
	var timeDiff = Math.abs(date2.getTime() - date1.getTime());
	var numberOfNights = Math.ceil(timeDiff / (1000 * 3600 * 24));

	var lodging = 103;
	if ($(".lodging .form-custom-option.selection").length > 0) lodging = $(".lodging .form-custom-option.selection").data("value");else lodging = $("#lodging").val();

	var dest = "";
	if ($(".island-parent .form-custom-option.selection").length > 0) dest = $(".island-parent .form-custom-option.selection").data("value");else dest = $(".island-parent #island").val();

	if (dest === "") {
		if ($(".span_valid_island").length < 1) {
			$(".island-parent").append("<span style='font-size: 12px;font-style: italic; color: red' class='span_valid_island'>Please select an island</span>");
		}
		return;
	}

	var subdest = "";
	if ($(".sub-location .form-custom-option.selection").length > 0) subdest = $(".sub-lobookincation .form-custom-option.selection").data("value");

	var urlBooking = "https://bahamas.bookdirect.net/redirect_booking.php?" + "campaign=bahamas-interior-bookingwidget&" + "rooms=1&" + (numberOfNights ? "nights=" + numberOfNights + "&" : "") + "sDay=sDay&" + "sMonth=sMonth&" + "sYear=sYear&" + "widget_id=1355&" + "start-date-1355=" + date_1.trim() + "&" + "end-date-1355=" + date_2.trim() + "&" + (lodging ? "lodgingID=" + lodging + "&" : "") + (subdest ? "jrs_city_group_id=" + subdest + "&" : "") + (dest && dest != 0 ? "jrs_location_group_id=" + dest + "&" : "") + "Submit=";

	if (typeof dataLayer != "undefined") {
		dataLayer.push({
			event: "bookingWidget",
			name: "Hotel Only"
		});
	}

	window.open(urlBooking);
	$(".span_valid_island").remove();
}

$(document).ready(function () {
	if (current_lan != "EN" && current_lan != "") {
		$.each($("a[href^='/']"), function (index, value) {
			$(this).attr("href", "/" + current_lan.toLowerCase() + $(this).attr("href"));
		});
	}

	$(".has_datepicker").datepicker({ dateFormat: "DD, m/d/yy" });

	$("#booking-form").on("submit", function () {
		if (booking_type == "hotel") {
			prepareQueryDirect();
		} else {
			prepareQueryBusyRooms(booking_type);
		}

		return false;
	});

	$(".clear-filters").on("click", function () {
		if (typeof search_dest != "undefined") search_dest = "";
		if (typeof search_area != "undefined") search_area = "";
		if (typeof search_date != "undefined") search_date = "";
		if (typeof search_date_end != "undefined") search_date_end = "";
		if (typeof search_interest != "undefined") search_interest = "";
		if (typeof search_rate != "undefined") search_rate = "";
		if (typeof search_package != "undefined") search_package = "";
		if (typeof search_promotion_board != "undefined") search_promotion_board = "";

		$("#filter-form input[type='text']").val("");
		$("#filter-form input[type='checkbox'").prop("checked", false);
		$(".check").removeClass("active");
		$(".form-custom-options .form-custom-option").removeClass("selection");
		$(".custom-sel-trigger").text("All");

		$("input#a[type='range']").val(0);
		$("input#b[type='range']").val($("input#b[type='range']").attr("max"));

		$(".wrap--2x").attr("style", "--min: 0; --max: " + $("input#b[type='range']").attr("max") + "; --a:0; --b:" + $("input#b[type='range']").attr("max") + "; --p: ");

		$(".selected-filter").html("");

		document.location = "#no-filters";

		current_page = 1;
		getSearch();

		return false;
	});
});

//TABS QUAD
$(function () {
	$.each($(".tabs-quad"), function (index, value) {
		$(this).find(".tabs-quad__content > div").eq($(this).find(".tabs-quad__list .active").index()).show();
		$(this).find(".tabs-img img").eq($(this).find(".tabs-quad__list .active").index()).show();
		var _this = this;
		$(this).find(".tabs-quad__list li").on("click", function (e) {
			var $current = $(e.currentTarget),
			    index = $current.index();

			$(_this).find(".tabs-quad__list li").removeClass("active");
			$current.addClass("active");

			$(_this).find(".tabs-quad__content > div").hide();
			$(_this).find(".tabs-quad__content > div").eq(index).show();

			$(_this).find(".tabs-img img").hide();
			$(_this).find(".tabs-img img").eq(index).show();
		});
	});

	//PEOPLE TO PEOPLE FORMS
	var peopleToPeopleForms = window.location.href;
	if (peopleToPeopleForms.indexOf("host-form") != "-1") {
		$("#host").css("display", "block");
		$("#guest").css("display", "none");
	}
	setTimeout(function () {
		$(".form-custom-option").bind("click", function () {
			var formValue = $(this).attr("data-value");
			if (formValue == "guest") {
				$("#guest").css("display", "block");
				$("#host").css("display", "none");
			} else if (formValue == "host") {
				$("#host").css("display", "block");
				$("#guest").css("display", "none");
			}
		});
	}, 100);

	//FAKEMAP PINS
	$(".island-map__pins div").on("click", function () {
		$(".island-map__pins div").removeClass("active");
		$(".island-info").css("display", "none");
		var currentId = $(this).attr("id");
		currentId = currentId.replace("label_", "content_");
		$("#" + currentId).css("display", "block");
		$(this).addClass("active");
		$(".island-info__close").css("display", "block");
		$(".fakemap .desktop").on("click", function () {
			$(".island-info").css("display", "none");
			$(".island-map__pins div").removeClass("active");
		});
	});
	$(".island-info__close").on("click", function () {
		$(".island-info").css("display", "none");
		$(".island-map__pins div").removeClass("active");
		$(".island-info__close").css("display", "none");
	});
});

//CHAIN ISLANDS
$(".chain-content__text button").on("click", function () {
	$(".chain-content__text .description").css({
		opacity: "0",
		"z-index": "-1"
	});
	$(".chain-content__slider .custom-arrows").css("opacity", "1");
	$(".chain-slider .btn-back").addClass("active");
});
$(".chain-slider .btn-back").on("click", function () {
	$(".chain-content__text .description").css({
		opacity: "1",
		"z-index": "1"
	});
	$(".chain-content__slider .custom-arrows").css("opacity", "0");
	$(".chain-slider .btn-back").removeClass("active");
});

//SEARCH BTN
var searchBtn = document.getElementById("search--btn");
var searchClose = document.getElementById("search--close");
var searchForm = document.getElementById("search--form");
var expandSearch = function expandSearch() {
	searchBtn.classList.toggle("close");
	searchForm.classList.toggle("active");
	$("#search").focus();
};
var closeSearch = function closeSearch() {
	searchBtn.classList.remove("close");
	searchForm.classList.remove("active");
};
if (searchBtn) {
	searchBtn.addEventListener("click", expandSearch);
}
//CLOSE SEARCH BAR ON CLICK OUTSIDE
$(document).mouseup(function (e) {
	var searchContainer = $("#search--form");
	if (!searchContainer.is(e.target) && searchContainer.has(e.target).length === 0) {
		searchContainer.removeClass("active");
	}
});

// ISLAND MAP COMPASS EFFECT
$(function () {
	$("#search--btn").on("click", function () {
		console.log(searchBtn.classList.contains("close"));
		if (!searchBtn.classList.contains("close")) $("#search--form").submit();
	});

	if ($(".covid-map").length) {
		$(".map-island").on("click", function (event) {
			event.stopPropagation();
			if ($(".map-island").hasClass("active")) {
				$(".map-island").removeClass("active");
			}

			$(this).addClass("active");
			if ($(".covid-map__info").hasClass("is-open")) {
				$(".covid-map__info").removeClass("is-open");
				$(".covid-map__default").css("opacity", "0");
				$(".covid-map__btns").css("display", "block");
			}

			$(".flying-map__close").show();
			$(".covid-map__pop").addClass("open");
			var id = $(this).attr("id");
			var data = $("div." + id).addClass("is-open");
			$(".covid-map__btns").css("display", "block");

			$(".covid-map .flying-map__close").on("click", function () {
				$(".covid-map__info").removeClass("is-open");
				$(".covid-map__default").css("opacity", "1");
				$(".flying-map__close").hide();
				$(".covid-map__btns").css("display", "none");
				$(".map-island").removeClass("active");
			});
		});
		$(".covid-map-btn").on("click", function (e) {
			e.preventDefault();
			$(".map-island.freeport").click();
			$(".covid-map__default").css("opacity", "0");
			if (winWidth < 1090) {
				$(".flying-map__close").hide();
			}
			//$('.covid-map__default').hide();
		});
		$(".covid-map__prev").on("click", function () {
			if ($(".map-island.active").prev().length > 0) {
				$(".map-island.active").prev().click();
				if (winWidth < 1090) {
					$(".flying-map__close").hide();
				}
			} else {
				$(".map-island").eq($(".map-island").length - 1).click();
				if (winWidth < 1090) {
					$(".flying-map__close").hide();
				}
			}
		});
		$(".covid-map__next").on("click", function () {
			if ($(".map-island.active").next().length > 0) {
				$(".map-island.active").next().click();
				if (winWidth < 1090) {
					$(".flying-map__close").hide();
				}
			} else {
				$(".map-island").eq(0).click();
				if (winWidth < 1090) {
					$(".flying-map__close").hide();
				}
			}
		});
	} else if ($(".home-flying-map").length || $(".airplane").length) {
		$(".map-island").on("click", function (event) {
			event.stopPropagation();
			if ($(".map-island").hasClass("active")) {
				$(".map-island").removeClass("active");
			}

			$(this).addClass("active");
			$(".flying-map__info").hide();
			$(".flying-map__pop").addClass("open");
			var id = $(this).attr("id");
			var data = $("div." + id).show();
			$(".map-decoration").hide();

			$(".flying-map__close").on("click", function () {
				$(".flying-map__info").hide();
				$(".flying-map__pop").removeClass("open");
				$(".map-decoration").show();
				$(".map-island").removeClass("active");
			});
			$(".flying-map__content").on("click", function () {
				$(".flying-map__info").hide();
				$(".flying-map__pop").removeClass("open");
				$(".map-decoration").show();
				$(".map-island").removeClass("active");
			});
		});
	} else {
		$(".map-island").on("click", function (event) {
			event.stopPropagation();

			if ($(".map-island").hasClass("active")) {
				$(".map-island").removeClass("active");
			}

			$(this).addClass("active");
			$(".flying-map__info").hide();
			$(".flying-map__pop").addClass("open");
			var id = $(this).attr("id");
			var data = $("div." + id).show();
			$(".map-decoration").hide();

			$(".flying-map__close").on("click", function () {
				$(".flying-map__info").hide();
				$(".flying-map__pop").removeClass("open");
				$(".map-decoration").show();
				$(".map-island").removeClass("active");
			});
			$(".flying-map__content").on("click", function () {
				$(".flying-map__info").hide();
				$(".flying-map__pop").removeClass("open");
				$(".map-decoration").show();
				$(".map-island").removeClass("active");
			});
		});
	}

	//ACCORDION
	$(".accordion-content__title").click(function () {
		$(this).parent().toggleClass("open");
		// setTimeout(function () {
		//   sliderAdaptiveHeight();
		// }, 10);
	});

	var sliderAdaptiveHeight = function sliderAdaptiveHeight() {
		var heights = [];
		var items = $(".slick-active");
		items.each(function () {
			heights.push($(this).height());
		});
		$(".slick-list").height(Math.max.apply(null, heights));
	};

	$(".destinations-map").hide();
	$(".destinations-slider").hide();
	$("#destinations-nav .button").on("click", function () {
		$("#destinations-nav .button").removeClass("active");
		$(this).addClass("active");
		$(".breadcrum").addClass("active");

		if ($(this).hasClass("map-view")) {
			$(".destinations-grid").hide();
			$(".destinations-slider").hide();
			$(".destinations-map").show();
			$(".flying-map__content").show();
			$(".destinations-views__nav").addClass("active");
			$("html, body").animate({ scrollTop: 0 }, "slow");
		} else if ($(this).hasClass("grid-view")) {
			$(".destinations-grid").show();
			$(".destinations-map").hide();
			$(".destinations-slider").hide();
			$(".breadcrum").removeClass("active");
			$(".destinations-views__nav").removeClass("active");
			$("html, body").animate({ scrollTop: 0 }, "slow");
		} else if ($(this).hasClass("full-view")) {
			$(".islands-slider .sym-slides").slick("unslick");
			$(".destinations-grid").hide();
			$(".destinations-map").hide();
			$(".destinations-slider").show();
			$(".destinations-views__nav").addClass("active");
			$(".islands-slider").each(function (index, sliderIsland) {
				var $sliderIsland = $(sliderIsland).find(".sym-slides");
				var $next = $(sliderIsland).find(".rightArrow");
				var $prev = $(sliderIsland).find(".leftArrow");

				$sliderIsland.slick({
					dots: false,
					autoplay: false,
					speed: 500,
					fade: true,
					accessibility: true,
					prevArrow: $prev,
					nextArrow: $next
				});
			});
			$("html, body").animate({ scrollTop: 0 }, "slow");
		}
	});

	//Custom Gallery button
	$("#open-fullsceen-gallery").click(function () {
		$("#custom-gallery-image-1").click();
	});

	//Home map
	$(".home-map .flying-map__content").show();

	//discover
	$(".discover .custom-option").on("click", function () {
		$(".discover-cont").slickUnfilter();

		var selected = $(this).data("target");
		if (selected == "all") return;

		$(".discover-cont").slick("slickFilter", "." + selected);
	});
});

$(".video-iframe").on("click", function (event) {
	event.preventDefault();
	$.fancybox({
		type: "iframe",
		// hide the related video suggestions and autoplay the video
		href: this.href.replace(new RegExp("watch\\?v=", "i"), "embed/") + "?rel=0&autoplay=1",
		overlayShow: true,
		centerOnScroll: true,
		speedIn: 100,
		speedOut: 50,
		allowfullscreen: true,
		width: "900px",
		height: "500px",
		autosize: false,
		iframe: {
			preload: false
		}
	});
});
$(".video-iframe2").fancybox({
	beforeShow: function beforeShow() {
		var wrapper = $.fancybox.wrap;
		wrapper.addClass("fullscreen-iframe");
	},
	afterShow: function afterShow() {
		var videoUrl = $(this).attr("data-video");
		console.log(videoUrl);
	}
});
$(".magazine-full").fancybox({
	beforeShow: function beforeShow() {
		var wrapper = $.fancybox.wrap;
		wrapper.addClass("fullscreen-magazine");
	}
});
$(".magazine-full2").fancybox({
	prevEffect: "none",
	nextEffect: "none",
	closeBtn: true,
	helpers: {
		title: { type: "inside" },
		buttons: {}
	},
	beforeShow: function beforeShow() {
		var wrapper = $.fancybox.wrap;
		wrapper.addClass("fullscreen-magazine");
	}
});

var videoUrl = void 0;
$(".open-video").click(function (event) {
	event.preventDefault();
	videoUrl = $(this).attr("data-video");
});
$(".fancybox-copy").fancybox({
	wrapCSS: "full-fancy-copy"
});
$(".open-video.autoplay").fancybox({
	afterShow: function afterShow() {
		$("#lightbox-video").attr("src", videoUrl);
		$("#lightbox-video").play();
	},
	overlayShow: true,
	centerOnScroll: true,
	speedIn: 100,
	speedOut: 50,
	allowfullscreen: true,
	width: "100%",
	height: "100%",
	autosize: false,
	closeClickOutside: true
});

$(".open-video").fancybox({
	afterShow: function afterShow() {
		$(".fancybox-overlay").addClass("fancy-video");
		$("#lightbox-video").attr("src", videoUrl);
		//$('#lightbox-video').play();
	},
	overlayShow: true,
	centerOnScroll: true,
	speedIn: 100,
	speedOut: 50,
	allowfullscreen: true,
	width: "100%",
	height: "100%",
	//autosize: false,
	closeClickOutside: true
});

$(".open-video").on("click", function () {
	//console.log('click en video para abrir fancybox')
	$(".fancybox-overlay").addClass("fancy-video");
});

var lightBoxContainer = $("#lightbox-video");
if (lightBoxContainer.length > 0) {
	$(document).on("click", function (e) {
		var container = $("#lightbox-video");
		if (!container.is(e.target) && container.has(e.target).length === 0) {
			$.fn.fancybox.close();
		}
	});
}

document.onkeydown = function (evt) {
	evt = evt || window.event;
	var isEscape = false;
	if ("key" in evt) {
		isEscape = evt.key === "Escape" || evt.key === "Esc";
	} else {
		isEscape = evt.keyCode === 27;
	}
	if (isEscape) {
		$.fn.fancybox.close();
	}
};

var videoUrl2 = void 0;
$("a.open-home-video").click(function (event) {
	console.log("click en primer video");
	$(this).removeAttr("target");
	event.preventDefault();
	videoUrl2 = $(this).attr("data-video");
	console.log(videoUrl2);
});

$(".open-home-video.autoplay").fancybox({
	afterShow: function afterShow() {
		$("#lightbox-second-video").attr("src", videoUrl2);
		$("#lightbox-second-video").play();
	},
	overlayShow: true,
	centerOnScroll: true,
	speedIn: 100,
	speedOut: 50,
	allowfullscreen: true,
	width: "100%",
	height: "100%",
	autosize: false,
	closeClickOutside: true
});

$(".open-home-video").fancybox({
	afterShow: function afterShow() {
		$(".fancybox-overlay").addClass("fancy-video");
		$("#lightbox-second-video").attr("src", videoUrl2);
	},
	overlayShow: true,
	centerOnScroll: true,
	speedIn: 100,
	speedOut: 50,
	allowfullscreen: true,
	width: "100%",
	height: "100%",
	closeClickOutside: true
});

$(".open-home-video").on("click", function () {
	$(".fancybox-overlay").addClass("fancy-video");
});

var lightBoxContainer2 = $("#lightbox-second-video");
if (lightBoxContainer2.length > 0) {
	$(document).on("click", function (e) {
		var container = $("#lightbox-second-video");
		if (!container.is(e.target) && container.has(e.target).length === 0) {
			$.fn.fancybox.close();
		}
	});
}

//ISLANDS GALLERY-VIDEO POP
var uvpNav = document.getElementById("uvp-nav");

if (uvpNav) {
	var openIslandPop = function openIslandPop(e) {
		e.preventDefault();
		islandPop.classList.add("open");
		islandDetailBreadcrum.style.display = "none";

		if (e.target.className.indexOf("video") != "-1") {
			$(".video-view").show();
			$(".gallery-view").hide();
		} else {
			$(".video-view").hide();
			$(".gallery-view").show();
		}
	};

	var closeIslandPop = function closeIslandPop() {
		islandPop.classList.remove("open");
		islandDetailBreadcrum.style.display = "block";
	};

	var islandPopBtn = uvpNav.querySelectorAll(".open-detail");
	var islandPop = document.getElementById("island-pop-detail");
	var islandcloseBtn = document.getElementById("close-island-pop");
	var islandDetailBreadcrum = document.querySelector(".breadcrum");

	if (islandPopBtn) {
		islandPopBtn.forEach(function (item, index) {
			item.addEventListener("click", openIslandPop);
		});
	}
	if (islandcloseBtn) {
		islandcloseBtn.addEventListener("click", closeIslandPop);
	}
}

//island gallery
$(".island-pop__nav .tab").on("click", function (e) {
	e.preventDefault();
	$(".island-pop__nav .tab").removeClass("active");
	$(this).addClass("active");

	if ($(this).hasClass("island-gallery")) {
		$(".gallery-view").show();
		$(".video-view").hide();
	} else if ($(this).hasClass("island-video")) {
		$(".video-view").show();
		$(".gallery-view").hide();
	}
});

function removeFilter(obj) {
	var filter_id = $(obj).attr("id");
	filter_id = filter_id.replace("filter_", "");

	$(obj).parent().parent().find("input[name='amenities_" + filter_id + "'], input[name='type_" + filter_id + "'], input[id='" + filter_id + "']").parent().click();
	$("#" + $(obj).attr("id")).remove();
}

/**
 * This method is used to send emails depends of Inquiry Field, create new fields into the CREATIVE BRIEF
 *
 * @param   {array}  data  all fields of form
 */
function creativeBriefSubmit(data) {
	var dataForm = data;
	dataForm.forEach(function (element, i) {
		//Delete elements
		if (element.name == "emailcc[]" || element.name == "sendto" || element.name == "subscribe")
			//|| element.name.indexOf('listrak[')>-1
			delete dataForm[i];
	});
	var isChange = 0;
	dataForm.forEach(function (element, i) {
		//Add emailcc
		if (element.name == "assets_required[]" && element.value == "Landing Page & Webform") {
			dataForm.push({ name: "sendto", value: "swells@bahamas.com" });
			isChange = 1;
		}

		if (element.name == "assets_required[]" && element.value == "Email Marketing") {
			dataForm.push({ name: "sendto", value: "swells@bahamas.com" });
			dataForm.push({ name: "emailcc[]", value: "adean@Bahamas.com" });
			isChange = 1;
		}
		//Add the person who it was submitted by get an email with a copy
		if (element.name == "email_address" && isChange === 0) {
			dataForm.push({ name: "sendto", value: element.value });
			isChange = 1;
		} else if (element.name == "email_address" && isChange === 1) {
			dataForm.push({ name: "emailcc[]", value: element.value });
		}
	});

	if (isChange === 1) {
		dataForm.push({ name: "notSaveLead", value: "true" });
		$.post(site_url + "/ajax/functions.php", dataForm, function (data) {
			console.log(data);
		});
	}
}

/**
 * This method is used to send emails depends of Inquiry Field, create new fields into the  MICE & Sports RFP
 *
 * @param   {array}  data  all fields of form
 */
function miceSportForm(data) {
	var dataForm = data;
	dataForm.forEach(function (element, i) {
		//Delete elements
		if (element.name == "emailcc[]" || element.name == "sendto" || element.name == "subscribe")
			//|| element.name.indexOf('listrak[')>-1
			delete dataForm[i];
	});
	var isChange = 0;
	dataForm.forEach(function (element, i) {
		//Add emailcc
		if (element.name == "group_type" && element.value == "Sporting Event") {
			dataForm.push({ name: "sendto", value: "Ldean@bahamas.com" });
			dataForm.push({
				name: "emailcc[]",
				value: "sportstourism@bahamas.com"
			});
			isChange = 1;
		}

		if (element.name == "group_type" && (element.value == "Meeting" || element.value == "Incentive" || element.value == "Conference" || element.value == "Exhibition/Event")) {
			dataForm.push({ name: "sendto", value: "jcuffie@bahamas.com" });
			dataForm.push({ name: "emailcc[]", value: " jgay@bahamas.com" });
			isChange = 1;
		}

		if (element.name == "group_type" && (element.value == "Social" || element.value == "Military" || element.value == "Education" || element.value == "Religious" || element.value == "Diversity")) {
			dataForm.push({ name: "sendto", value: "dwatson@bahamas.com" });
			isChange = 1;
		}
	});

	if (isChange === 1) {
		dataForm.push({ name: "notSaveLead", value: "true" });
		$.post(site_url + "/ajax/functions.php", dataForm, function (data) {
			console.log(data);
		});
	}
}

/**
 * This method is used to send emails depends of Inquiry Field, create new fields into the  Bahamas Ambassador Application form
 *
 * @param   {array}  data  all fields of form
 */
function baApplicationSubmit(data) {
	var dataForm = data;
	dataForm.forEach(function (element, i) {
		//Delete elements
		if (element.name == "emailcc[]" || element.name == "sendto" || element.name == "subscribe")
			//|| element.name.indexOf('listrak[')>-1
			delete dataForm[i];
	});
	var isChange = 0;
	dataForm.forEach(function (element, i) {
		//Add emailcc
		if (element.name == "which_type_of_ambassador_are_you_applying_to_be_" && element.value == "Boating") {
			dataForm.push({ name: "sendto", value: "awilliams@bahamas.com" });
			dataForm.push({
				name: "emailcc[]",
				value: "swilliams@bahamas.com"
			});
			isChange = 1;
		}
		if (element.name == "which_type_of_ambassador_are_you_applying_to_be_" && element.value == "Diving") {
			dataForm.push({ name: "sendto", value: "abethel@bahamas.com" });
			dataForm.push({ name: "emailcc[]", value: "irodgers@bahamas.com" });
			isChange = 1;
		}
		if (element.name == "which_type_of_ambassador_are_you_applying_to_be_" && element.value == "Flying") {
			dataForm.push({ name: "sendto", value: "grolle@bahamas.com" });
			dataForm.push({ name: "emailcc[]", value: "ash@bahamas.com" });
			isChange = 1;
		}
	});

	if (isChange === 1) {
		dataForm.push({ name: "notSaveLead", value: "true" });
		$.post(site_url + "/ajax/functions.php", dataForm, function (data) {
			console.log(data);
		});
	}
}

/**
 * This method is used to send emails depends of Inquiry Field, create new fields into the Contact Us form
 *
 * @param   {array}  data  all fields of form
 */
function contactSubmit(data) {
	var dataForm = data;
	dataForm.forEach(function (element, i) {
		//Delete elements
		if (element.name == "emailcc[]" || element.name == "sendto" || element.name == "subscribe")
			//|| element.name.indexOf('listrak[')>-1
			delete dataForm[i];
	});
	var isChange = 0,
	    isExistGI = 0,
	    isLatinAmerica = 0,
	    isEurope = 0,
	    country = 0,
	    isExistMC = 0;
	dataForm.forEach(function (element, i) {
		//Add emailcc
		if (element.name == "inquiry" && element.value == "Weddings & Honeymoons") {
			dataForm.push({ name: "sendto", value: "romance@bahamas.com" });
			isChange = 1;
		}
		if (element.name == "inquiry" && element.value == "Group Travel") {
			dataForm.push({ name: "sendto", value: "groups@bahamas.com" });
			isChange = 1;
		}
		if (element.name == "inquiry" && element.value == "Media/Communications") {
			dataForm.push({
				name: "sendto",
				value: "wswbahamas@webershandwick.com"
			});
			dataForm.push({ name: "emailcc[]", value: "ajohnson@bahamas.com" });
			isChange = 1;
			isExistMC = 1;
		}
		if (element.name == "inquiry" && element.value == "Travel Agents") {
			dataForm.push({ name: "sendto", value: "dpsmith@bahamas.com" });
			isChange = 1;
		}
		if (element.name == "inquiry" && (element.value == "Diving" || element.value == "Fishing")) {
			dataForm.push({ name: "sendto", value: "abethel@bahamas.com" });
			dataForm.push({ name: "emailcc[]", value: "grolle@bahamas.com" });
			isChange = 1;
		}
		if (element.name == "inquiry" && (element.value == "Boating" || element.value == "Fishing")) {
			if (element.value == "Boating") {
				dataForm.push({
					name: "emailcc[]",
					value: "grolle@bahamas.com"
				});
				dataForm.push({ name: "sendto", value: "jlord@bahamas.com" });
			} else {
				dataForm.push({
					name: "emailcc[]",
					value: "awilliams@bahamas.com"
				});
			}
			isChange = 1;
		}
		if (element.name == "inquiry" && element.value == "Cruises") {
			dataForm.push({ name: "sendto", value: "cstuart@bahamas.com" });
			isChange = 1;
		}
		if (element.name == "inquiry" && element.value == "Private Flying") {
			dataForm.push({ name: "sendto", value: "grolle@bahamas.com" });
			isChange = 1;
		}
		if (element.name == "inquiry" && element.value == "General Inquiries") {
			isExistGI = 1;
		}
		if (element.name == "region" && element.value == "Latin America") {
			isLatinAmerica = 1;
		}
		if (element.name == "region" && element.value == "Europe") {
			isEurope = 1;
		}
		//Country Validation
		if (element.name == "country" && element.value == "Italy") {
			country = 1;
		}
		if (element.name == "country" && element.value == "France") {
			country = 2;
		}
		if (element.name == "country" && element.value == "UK") {
			country = 3;
		}
	});

	if (isLatinAmerica == 1 && isExistGI == 1) {
		dataForm.push({ name: "sendto", value: "rcarey@bahamas.com" });
		isChange = 1;
	}
	if (isEurope == 1 && isExistGI == 1) {
		dataForm.push({ name: "sendto", value: "info@bahamas.co.uk" });
		isChange = 1;
	}

	//add emails by country validation
	if (isEurope == 1 && isExistMC == 1 && country == 1) {
		dataForm.forEach(function (element, i) {
			//Delete elements
			if (element.name == "emailcc[]" || element.name == "sendto")
				//|| element.name.indexOf('listrak[')>-1
				delete dataForm[i];
		});
		dataForm.push({
			name: "sendto",
			value: "bahamasitaly@openmindconsulting.it"
		});
		isChange = 1;
	}
	if (isEurope == 1 && isExistMC == 1 && country == 2) {
		dataForm.forEach(function (element, i) {
			//Delete elements
			if (element.name == "emailcc[]" || element.name == "sendto")
				//|| element.name.indexOf('listrak[')>-1
				delete dataForm[i];
		});
		dataForm.push({ name: "sendto", value: "bahamasfr@articleonze.com" });
		isChange = 1;
	}
	if (isEurope == 1 && isExistMC == 1 && country == 3) {
		dataForm.forEach(function (element, i) {
			//Delete elements
			if (element.name == "emailcc[]" || element.name == "sendto")
				//|| element.name.indexOf('listrak[')>-1
				delete dataForm[i];
		});
		dataForm.push({ name: "sendto", value: "bahamas@finnpartners.com" });
		isChange = 1;
	}

	if (isChange === 1) {
		dataForm.push({ name: "notSaveLead", value: "true" });
		$.post(site_url + "/ajax/functions.php", dataForm, function (data) {
			console.log(data);
		});
	}
}

/**
 * This method is used to send emails depends of Country selection dropdown into the Media & Influencer Request Form
 *
 * @param   {array}  data  all fields of form
 */
function mediaInfluencerSubmit(data) {
	var dataForm = data;
	dataForm.forEach(function (element, i) {
		//Delete elements
		if (element.name == "emailcc[]" || element.name == "sendto" || element.name == "subscribe")
			//|| element.name.indexOf('listrak[')>-1
			delete dataForm[i];
	});
	var isChange = 0;
	dataForm.forEach(function (element, i) {
		//Add emailcc
		if (element.name == "country" && (element.value == "United States" || element.value == "Other")) {
			dataForm.push({
				name: "sendto",
				value: "wswbahamas@webershandwick.com"
			});
			isChange = 1;
		}
		if (element.name == "country" && element.value == "Canada") {
			dataForm.push({ name: "sendto", value: "nblazier@jessonco.com" });
			isChange = 1;
		}
		if (element.name == "country" && element.value == "Italy") {
			dataForm.push({
				name: "sendto",
				value: "bahamasitaly@openmindconsulting.it"
			});
			isChange = 1;
		}
		if (element.name == "country" && element.value == "France") {
			dataForm.push({
				name: "sendto",
				value: "bahamasfr@articleonze.com"
			});
			isChange = 1;
		}
		if (element.name == "country" && element.value == "United Kingdom") {
			dataForm.push({
				name: "sendto",
				value: "bahamas@finnpartners.com"
			});
			isChange = 1;
		}
	});

	if (isChange === 1) {
		dataForm.push({ name: "notSaveLead", value: "true" });
		$.post(site_url + "/ajax/functions.php", dataForm, function (data) {
			console.log(data);
		});
	}
}

function autocomplete(inp, arr) {
	/*the autocomplete function takes two arguments,
    the text field element and an array of possible autocompleted values:*/
	var currentFocus;
	/*execute a function when someone writes in the text field:*/
	inp.addEventListener("input", function (e) {
		var a,
		    b,
		    i,
		    val = this.value;
		/*close any already open lists of autocompleted values*/
		closeAllLists();
		if (!val) {
			return false;
		}
		currentFocus = -1;
		/*create a DIV element that will contain the items (values):*/
		a = document.createElement("DIV");
		a.setAttribute("id", this.id + "autocomplete-list");
		a.setAttribute("class", "autocomplete-items");
		/*append the DIV element as a child of the autocomplete container:*/
		this.parentNode.appendChild(a);
		/*for each item in the array...*/
		for (i = 0; i < arr.length; i++) {
			/*check if the item starts with the same letters as the text field value:*/
			var label = arr[i].toUpperCase();
			var value = val.toUpperCase();
			if (label.indexOf(value) != "-1") {
				/*create a DIV element for each matching element:*/
				b = document.createElement("DIV");
				/*make the matching letters bold:*/
				b.innerHTML = "<strong>" + arr[i].substr(0, val.length) + "</strong>";
				b.innerHTML += arr[i].substr(val.length);
				/*insert a input field that will hold the current array item's value:*/
				b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
				/*execute a function when someone clicks on the item value (DIV element):*/
				b.addEventListener("click", function (e) {
					/*insert the value for the autocomplete text field:*/
					inp.value = this.getElementsByTagName("input")[0].value;
					/*close the list of autocompleted values,
                    (or any other open lists of autocompleted values:*/
					closeAllLists();
				});
				a.appendChild(b);
			}
		}
	});
	/*execute a function presses a key on the keyboard:*/
	inp.addEventListener("keydown", function (e) {
		var x = document.getElementById(this.id + "autocomplete-list");
		if (x) x = x.getElementsByTagName("div");
		if (e.keyCode == 40) {
			/*If the arrow DOWN key is pressed,
            increase the currentFocus variable:*/
			currentFocus++;
			/*and and make the current item more visible:*/
			addActive(x);
		} else if (e.keyCode == 38) {
			//up
			/*If the arrow UP key is pressed,
            decrease the currentFocus variable:*/
			currentFocus--;
			/*and and make the current item more visible:*/
			addActive(x);
		} else if (e.keyCode == 13) {
			/*If the ENTER key is pressed, prevent the form from being submitted,*/
			e.preventDefault();
			if (currentFocus > -1) {
				/*and simulate a click on the "active" item:*/
				if (x) x[currentFocus].click();
			}
		}
	});
	function addActive(x) {
		/*a function to classify an item as "active":*/
		if (!x) return false;
		/*start by removing the "active" class on all items:*/
		removeActive(x);
		if (currentFocus >= x.length) currentFocus = 0;
		if (currentFocus < 0) currentFocus = x.length - 1;
		/*add class "autocomplete-active":*/
		x[currentFocus].classList.add("autocomplete-active");
	}
	function removeActive(x) {
		/*a function to remove the "active" class from all autocomplete items:*/
		for (var i = 0; i < x.length; i++) {
			x[i].classList.remove("autocomplete-active");
		}
	}
	function closeAllLists(elmnt) {
		/*close all autocomplete lists in the document,
        except the one passed as an argument:*/
		var x = document.getElementsByClassName("autocomplete-items");
		for (var i = 0; i < x.length; i++) {
			if (elmnt != x[i] && elmnt != inp) {
				x[i].parentNode.removeChild(x[i]);
			}
		}
	}
	/*execute a function when someone clicks in the document:*/
	document.addEventListener("click", function (e) {
		closeAllLists(e.target);
	});
}

/*An array containing all the country names in the world:*/
/*initiate the autocomplete function on the "myInput" element, and pass along the countries array as possible autocomplete values:*/
if ($("#airport").length > 0) autocomplete(document.getElementById("airport"), countries);

function addVimeo(videoUrl, parentContainer, lightbox, size) {
	//setting the video iframe
	var newIframe = document.createElement("iframe");
	newIframe.setAttribute("src", videoUrl);
	newIframe.setAttribute("frameborder", 0);
	newIframe.setAttribute("allowfullscreen", true);

	if (lightbox === true) {
		var newlightbox = document.createElement("div");
		newlightbox.classList.add("lightbox__container");
		var lightboxBox = document.createElement("div");
		lightboxBox.classList.add("lightbox__box");
		lightboxBox.classList.add(size);

		var lightboxClose = document.createElement("div");
		lightboxClose.classList.add("lightbox__close");

		lightboxBox.appendChild(lightboxClose);
		lightboxClose.addEventListener("click", function () {
			document.getElementById(parentContainer).classList.remove("opened");
			var allIframes = document.getElementsByTagName("iframe");
			for (var i = 0; i < allIframes.length; i++) {
				var tempSrc = allIframes[i].getAttribute("src");
				allIframes[i].setAttribute("src", "");
			}
		});

		lightboxBox.appendChild(newIframe);
		newlightbox.appendChild(lightboxBox);
		if (parentContainer) {
			document.getElementById(parentContainer).appendChild(newlightbox);
		}
		if (size === "full") {
			if (windowWidth / 2 > windowHeight) {
				newIframe.setAttribute("width", windowHeight * 1.77);
				newIframe.setAttribute("height", windowHeight);
				lightboxBox.style.width = windowHeight * 1.77 + "px";
			} else {
				newIframe.setAttribute("width", windowWidth);
				newIframe.setAttribute("height", windowWidth / 1.77);
				lightboxBox.style.width = windowWidth + "px";
			}
		}
	}
}
var w = window,
    d = document,
    e = d.documentElement,
    g = d.getElementsByTagName("body")[0],
    windowWidth = w.innerWidth || e.clientWidth || g.clientWidth,
    windowHeight = w.innerHeight || e.clientHeight || g.clientHeight;

(function () {
	window.onload = function () {
		window.addEventListener("resize", function () {
			// resizeWindow();
		});
	};
})();

var vimeoDolphin = document.getElementById("vimeoDolphin");

if (vimeoDolphin) {
	vimeoDolphin.addEventListener("click", function () {
		document.getElementById("vimeoVideoDolphin").classList.add("opened");
		addVimeo("https://www.youtube.com/embed/99txg5Lyaac", "vimeoVideoDolphin", true, "full");
	});
}

var popVideo = document.getElementById("popInVideo");

if (popVideo) {
	popVideo.addEventListener("click", function () {
		document.getElementById("vimeoVideoPopIn").classList.add("opened");
		addVimeo("https://www.youtube.com/embed/99txg5Lyaac", "vimeoVideoPopIn", true, "full");
	});
}

var parent = $(".vimeoframe");
var children = parent.children(".text");

/**
 * Boating Fling
 */
if (window.location.pathname.indexOf("boating-fling-registration") !== false) {
	var boatingFling = document.querySelector("select[name=boating_fling_island]"),
	    biminiDate = document.querySelector("select[name=bimini_dates]"),
	    grandBahamaDate = document.querySelector("select[name=grand_bahama_date]"),
	    exumaExtendedDate = document.querySelector("select[name=exuma_extended_date]"),
	    dynamicTitleHidden = document.querySelector("input[name=dynamictitle]");

	if (boatingFling != null) {
		boatingFling.addEventListener("change", function () {
			dynamicTitleHidden.value = "";
			biminiDate.seletedIndex = 0;
			grandBahamaDate.seletedIndex = 0;
			if (exumaExtendedDate) {
				exumaExtendedDate.seletedIndex = 0;
			}
		});

		biminiDate.addEventListener("change", function () {
			dynamicTitleHidden.value = this.value + ", " + boatingFling.value;
		});

		grandBahamaDate.addEventListener("change", function () {
			dynamicTitleHidden.value = this.value + ", " + boatingFling.value;
		});

		if (exumaExtendedDate) {
			exumaExtendedDate.addEventListener("change", function () {
				dynamicTitleHidden.value = this.value + ", " + boatingFling.value;
			});
		}
	}
}

// vanilla js scroll TO animation
function animateTo(target) {
	var gotoTarget = offset(document.getElementById(target)).top - 200;
	var from = window.pageYOffset;
	var to = gotoTarget;
	var duration = 1300;
	var start = new Date().getTime();

	//time interval
	var timer = setInterval(function () {
		var time = new Date().getTime() - start;

		if (from <= to) {
			var y = easeInOutQuart(time, from, to - from, duration);
		} else {
			var y = easeInOutQuart(time, from, -(from - to), duration);
		}
		window.scrollTo(0, y);
		if (time >= duration) clearInterval(timer);
	}, 1000 / 60);

	window.scrollTo(0, from);
}
//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
	var rect = el.getBoundingClientRect(),
	    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
	    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}

// URL FUNCTIONALITY
(function () {
	var url = window.location.href;

	function getParameterValueFromURL(url, parameterName) {
		var parameters = {};
		var queryString = url.split("?")[1];

		if (queryString) {
			var pairs = queryString.split("&");

			for (var i = 0; i < pairs.length; i++) {
				var pair = pairs[i].split("=");
				var key = decodeURIComponent(pair[0]);
				var value = decodeURIComponent(pair[1]);

				parameters[key] = value;
			}
		}

		if (parameters.hasOwnProperty(parameterName)) {
			return parameters[parameterName];
		} else {
			return null;
		}
	}

	function updateDomSection(searchedValue) {
		var tabButtons = document.querySelectorAll(".tabs-slider__list li");

		tabButtons.forEach(function (button) {
			var buttonText = button.textContent.toLowerCase().replace(" ", "-");

			if (buttonText === searchedValue) {
				button.click();
			}
		});
	}

	if (document.getElementById("tabs-171")) {
		var parameterName = "tab";
		var searchedValue = getParameterValueFromURL(url, parameterName);

		updateDomSection(searchedValue);

		var section = document.getElementById("tabs-171");
		var offset_top = section.offsetTop;
		window.scroll({ top: offset_top, behavior: "smooth" });
	}

	if (document.getElementById("form_id-280")) {
		var updateInput = function updateInput() {
			// console.log( selectType.value );
			state.type = capitalizeText(selectType.value);

			if (selectType.value === "bimini_") {
				state.date = capitalizeText(selectDate.value);
			}

			if (selectType.value === "grand_bahama") {
				state.date = capitalizeText(selectDateGrand_Bahana.value);
			}

			if (selectType.value === "eleuthera_extended") {
				state.date = capitalizeText(selectDateElectra.value);
			}

			console.log(state);

			// console.log( state );
			empty.value = state.date.replace(/(\d)/, " $1") + ": " + state.type;

			proccesInput(empty);
		};

		var form_280 = document.getElementById("form_id-280");
		var selectType = document.getElementById("id_2_280");
		var selectDate = document.getElementById("id_3_280");
		var selectDateGrand_Bahana = document.getElementById("id_4_280");
		var selectDateElectra = document.getElementById("id_5_280");
		var empty = document.querySelector("#id_1_280");

		console.log({ empty: empty });

		var state = {
			type: "",
			date: ""
		};

		selectDate.addEventListener("change", updateInput);
		selectType.addEventListener("change", updateInput);
		selectDateGrand_Bahana.addEventListener("change", updateInput);
		selectDateElectra.addEventListener("change", updateInput);

		form_280.addEventListener("submit", function (e) {
			var dateSelected = getDateSelected(state.date),
			    inwardDeclarationInput = form_280.querySelector('input[name="inward_declaration_link"]'),
			    paymentsPermitsInput = form_280.querySelector('input[name="payments_permits_link"]'),
			    clearingOutwardInput = form_280.querySelector('input[name="clearing_outward_link"]'),
			    dateForGoogleCalendar = "https://calendar.google.com/calendar/u/0/r/eventedit?";

			inwardDeclarationInput.value = dateForGoogleCalendar + dateSelected + "&location=Bahia%20Mar%20Marina&text=Inward+Declaration";
			paymentsPermitsInput.value = dateForGoogleCalendar + dateSelected + "&location=801%20Seabreeze%20Blvd&text=PAYMENTS+%26+PERMITS";
			clearingOutwardInput.value = dateForGoogleCalendar + dateSelected + "&location=Ft.%20Lauderdale,%20FL,%2033316&text=CLEARING+OUTWARD+BOUND";
		});
	}

	function getDateSelected(date) {
		var date_string_to_retur = "";
		var date_splited = date.split("_");
		var each_day = date_splited[1].split("-");

		each_day.forEach(function (day, index) {
			var dateFromMethodDate = new Date(date_splited[0] + " " + day + " " + date_splited[3]);
			dateFromMethodDate.setDate(dateFromMethodDate.getDate() + 1);
			var m = dateFromMethodDate.getMonth();
			var d = dateFromMethodDate.getDate();
			var y = dateFromMethodDate.getFullYear();
			m++; /* This is necessary because the getMonth() method get back january as '0' */

			m = m.toString();
			d = d.toString();
			y = y.toString();

			m = returnDateWithZero(m);
			d = returnDateWithZero(d);

			date_string_to_retur += "" + (index == 0 ? "dates=" : "") + (y + m + d) + "T000000Z" + (index == 0 ? "/" : "");
		});

		return date_string_to_retur;
	}

	function returnDateWithZero(date) {
		return !date.includes("0") && date.length == 1 ? "0" + date : date;
	}

	function proccesInput(inputElement) {
		var valorInput = inputElement.value;
		var valorProcesado = valorInput.replace(/2024/g, "");
		valorProcesado = valorProcesado.replace("_extended", " Extended");
		valorProcesado = valorProcesado.replace("_bahama", " Bahama");
		valorProcesado = valorProcesado.replaceAll("_", "");
		inputElement.value = valorProcesado;
	}

	function capitalizeText(text) {
		return text.toLowerCase().replace(/(^|\s)\S/g, function (match) {
			return match.toUpperCase();
		});
	}

	document.documentElement.style.setProperty("--header-height", document.getElementById("header").clientHeight + "px");
})();

function addAgencyPixel(tag, ids) {
	var ftRandom = Math.random() * 1000000;
	var scriptSrc = "https://servedby.flashtalking.com/container/" + ids + ";iframe/?spotName=" + tag + "&cachebuster=" + ftRandom;
	var iframe = document.createElement("iframe");
	iframe.style.position = "absoulte";
	iframe.style.visibility = "hidden";
	iframe.style.width = "1px";
	iframe.style.height = "1px";
	iframe.src = scriptSrc;
	document.body.append(iframe);
}

var pixelLinks = [["[data-name=WestJet]", "Bahamas_West_Jet", "32681;145380;16637"], [".satisfi_chat-button", "Bahamas_Ask_a_Question", "32681;145383;16637"], ["[alt='sunwing logo']", "Bahamas_Sunwing", "32681;145381;16637"], ["[data-name='Sunwing']", "Bahamas_Sunwing", "32681;145381;16637"], ["[data-name='Air Canada']", "Bahamas_Air_Canada", "32681;145382;16637"]];

setTimeout(function () {
	pixelLinks.forEach(function (item) {
		var links = [].concat(_toConsumableArray(document.querySelectorAll(item[0])));
		links.forEach(function (link) {
			if (link) {
				link.addEventListener("click", function (e) {
					addAgencyPixel(item[1], item[2]);
				});
			}
		});
	});
}, 2000);

// Function to add a click event listener to a button to trigger addAgencyPixel()
function addClickListenerToChatButton(callback) {
	var button = document.querySelector(".satisfi_chat-button-trigger");
	if (button) {
		button.addEventListener("click", callback);
		// console.log('Click event listener added to the button.');
	} else {
			// console.error('Button with class "satisfi_chat-button-trigger" not found.');
		}
}
function onChatButtonClick() {
	document.getElementsByClassName("satisfi_chat-button")[0].click();
}
addClickListenerToChatButton(onChatButtonClick);